import { Menu, Stethoscope, LogOut } from 'lucide-react';
import { useClerk, useAuth } from '@clerk/react';
import { useGlobalContext } from './useGlobalContext';

export function Navbar() {
  const { toggleSidebar, patient, setPatient, setToast } = useGlobalContext();
  const { signOut } = useClerk();
  const { isSignedIn } = useAuth();

  const handleLogout = async () => {
    setPatient({ email: '', name: '', age: 18, gender: 'male' });
    localStorage.removeItem('homeopathy_patient');
    await signOut({ redirectUrl: '/' });
    setToast({ type: 'success', message: 'Session closed.' });
  };

  return (
    <div className="navbar bg-primary text-primary-content shadow-md">
      <div className="flex-none">
        <button
          type="button"
          aria-label="Open sidebar menu"
          className="btn btn-ghost btn-square text-primary-content"
          onClick={toggleSidebar}
        >
          <Menu size={22} />
        </button>
      </div>
      <div className="flex-1 flex items-center gap-2 pl-2">
        <Stethoscope size={22} />
        <span className="text-lg font-semibold">Homeopathic Consultation</span>
      </div>
      {isSignedIn && (
        <div className="flex-none flex items-center gap-3">
          <div className="hidden md:flex items-center gap-2">
            <div className="avatar placeholder">
              <div className="bg-secondary text-secondary-content rounded-full w-9">
                <span className="text-sm font-bold">
                  {patient.name.slice(0, 1).toUpperCase()}
                </span>
              </div>
            </div>
            <span className="text-sm">{patient.name}</span>
          </div>
          <button
            type="button"
            className="btn btn-sm btn-ghost text-primary-content"
            onClick={handleLogout}
          >
            <LogOut size={16} className="mr-1" /> Log out
          </button>
        </div>
      )}
    </div>
  );
}
